import { useEffect, useRef, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux/store'
import Form from '../Form'
import FormItem from '../Form/FormItem'
import Button from '../General/Button'
import Datepicker from '../Inputs/Datepicker'
import InputText from '../Inputs/InputText'
import Select from '../Inputs/Select'
import Switch from '../Inputs/Switch'

const FloatingSaleHistoricSearch: React.FC<IFloatingSaleHistoricSearch> = ({
  onClose,
  onSubmitValue,
}) => {
  const form = useForm()

  const [windowWidth, setWindowWidth] = useState<number>(0)

  const currencies: SelectOptions[] = useSelector(
    (state: RootState) => state.curr.currencies
  ).map((v) => ({ text: v.name, value: v.id + '' }))


  const [isDateSelected, setIsDateSelected] = useState<boolean>(false)

  useEffect(() => {
    const { innerWidth } = window
    setWindowWidth(innerWidth)
  }, [])

  // useEffect(() => {
  //   console.log("EL FORM", form.getValues("toDate"))
  // }, [form.watch("toDate")])

  // const currencyOptions: SelectOptions[] = [
  //   {
  //     value: 'date',
  //     text: 'Fecha',
  //   },
  //   {
  //     value: 'correlativeNumber',
  //     text: 'Correlativo',
  //   },
  //   {
  //     value: 'creditNote',
  //     text: 'Nota de crédito',
  //   },
  // ]

  // const [selectedOption, setSelectedOption] = useState<string>('')

  return (
    <Form form={form} onSubmit={(values) => onSubmitValue({...values, isDateSelected})} classes="gap-x-6 gap-y-2">
      <h2 className="col-span-12 text-primary-900 font-bold dark:text-white mb-3">
        Búsqueda Avanzada
      </h2>

      <FormItem name="username" classes="lg:col-span-8 col-span-12">
        <InputText small label="Usuario" maxLength={80} />
      </FormItem>

      <FormItem name="paidOut">
        <div className="flex items-center h-full">
          <Switch label="Pagado" forForm={true} />
        </div>
      </FormItem>

      <FormItem name="invoiceCode" classes="lg:col-span-8 col-span-12">
        <InputText small label="Código de factura" maxLength={80} />
      </FormItem>

      {/* <FormItem name="paidOut">
        <div className="flex items-center h-full">
          <Switch
            label="Buscar por fecha"
            forForm={true}
            value={searchByDate}
            onChange={(value) => setSearchByDate(value)}
          />
        </div>
      </FormItem> */}

      <div className='lg:col-span-6 col-span-12' onClick={() => {
        setIsDateSelected(true)
      }}>
        <FormItem name="fromDate" classes="lg:col-span-6 col-span-12">
          <Datepicker label="Fecha desde"  />
        </FormItem>
      </div>

      <div className="lg:col-span-6 col-span-12" onClick={() => {
        setIsDateSelected(true)
      }}>
        <FormItem name="toDate" classes="lg:col-span-6 col-span-12">
          <Datepicker label="Fecha hasta" />
        </FormItem>
      </div>

    

      {/* <FormItem
        name="code"
        defaultValue={currencies[0]}
        classes="lg:col-span-4 col-span-12"
      >
        <Select
          options={currencies}
          // setSelectedHelper={(values) => setTypeSelected(values.value)}
          label="Tipo"
        />
      </FormItem> */}

      <div className="col-span-12 flex space-x-2 px-1 mt-3">
        <Button
          type="outline"
          classes="w-1/2 mr-4"
          htmlType="button"
          onClick={() => onClose()}
        >
          Cancelar
        </Button>
        <Button type="primary" classes="w-1/2 mr-4" htmlType="submit">
          Buscar
        </Button>
      </div>
    </Form>
  )
}

interface IFloatingSaleHistoricSearch {
  onClose: Function
  onSubmitValue: Function
}

interface SelectOptions {
  text: string
  value: string
}

export default FloatingSaleHistoricSearch
